// extracted by mini-css-extract-plugin
module.exports = {"DetainmentBox":"Detainment_DetainmentBox__3iu0s","ImgBox":"Detainment_ImgBox__3liLg","footer":"Detainment_footer__2ckFX"};